import React from 'react'

import { useFocusMode } from '../../blocs/useFocusMode'

import { FocusChat } from './Panes/FocusChat/FocusChat'
import { FocusParticipants } from './Panes/FocusParticipants/FocusParticipants'
import { FocusQuestions } from './Panes/FocusQuestions/FocusQuestions'
import { FocusScreens } from './Panes/FocusScreens/FocusScreens'
import { FocusTray } from './Panes/FocusTray/FocusTray'
import { FocusStage } from './Panes/FocusStage/FocusStage'

import './FocusPane.scss'

interface FocusPaneProps {
  idx: number
}

const FocusPane = ({ idx }: FocusPaneProps) => {
  const { panes } = useFocusMode()

  const pane = panes[idx]

  if (!pane) return null

  return (
    <div
      className="focus-pane"
      data-pane={pane.mode}
      data-pane-count={panes.length}
    >
      {pane.mode === 'stage' && <FocusStage />}
      {pane.mode === 'chat' && <FocusChat />}
      {pane.mode === 'tray-slides' && (
        <FocusTray filter={['image', 'breaker', 'video']} />
      )}
      {pane.mode === 'tray-notes' && <FocusTray filter={['note', 'breaker']} />}
      {pane.mode === 'participants' && (
        <FocusParticipants participantIds={pane.participantIds} />
      )}
      {pane.mode === 'screens' && <FocusScreens screenIds={pane.screenIds} />}
      {pane.mode === 'questions' && <FocusQuestions />}
    </div>
  )
}

export { FocusPane }
